export const RESET_CREAR_DEX = 'RESET_CREAR_DEX';
export const RESET_EDITAR_DEX = 'RESET_EDITAR_DEX';

export const USERS_DEX_PANEL_LOADING = 'USERS_DEX_PANEL_LOADING';
export const USERS_DEX_PANEL_LOAD = 'USERS_DEX_PANEL_LOAD';
export const USERS_DEX_PANEL_ERROR = 'USERS_DEX_PANEL_ERROR';
export const USERS_DEX_PANEL_RESET = 'USERS_DEX_PANEL_RESET';

export const USERSINDI_DEX_PANEL_LOADING = 'USERSINDI_DEX_PANEL_LOADING';
export const USERSINDI_DEX_PANEL_LOAD = 'USERSINDI_DEX_PANEL_LOAD';
export const USERSINDI_DEX_PANEL_ERROR = 'USERSINDI_DEX_PANEL_ERROR';
export const USERSINDI_DEX_PANEL_RESET = 'USERSINDI_DEX_PANEL_RESET';

export const USERDEX_OBS_PANEL_LOADING = 'USERDEX_OBS_PANEL_LOADING';
export const USERDEX_OBS_PANEL_LOADED = 'USERDEX_OBS_PANEL_LOADED';
export const USERDEX_OBS_PANEL_ERROR = 'USERDEX_OBS_PANEL_ERROR';
export const USERDEX_OBS_PANEL_RESET = 'USERDEX_OBS_PANEL_RESET';

export const OBSDEX_ACCION_LOADING = 'OBSDEX_ACCION_LOADING';
export const OBSDEX_ACCION_SUCCESS = 'OBSDEX_ACCION_SUCCESS';
export const OBSDEX_ACCION_ERROR = 'OBSDEX_ACCION_ERROR';
export const OBSDEX_ACCION_RESET = 'OBSDEX_ACCION_RESET';

export const DEX_LOADING = 'DEX_LOADING';
export const DEX_LOADED = 'DEX_LOADED';
export const DEX_ERROR = 'DEX_ERROR';

export const RANKING_DEX_USER_LOADING = 'RANKING_DEX_USER_LOADING';
export const RANKING_DEX_USER_LOADED = 'RANKING_DEX_USER_LOADED';
export const RANKING_DEX_USER_ERROR = 'RANKING_DEX_USER_ERROR';

export const RANKING_DEX_ESPECIE_LOADING = 'RANKING_DEX_ESPECIE_LOADING';
export const RANKING_DEX_ESPECIE_LOADED = 'RANKING_DEX_ESPECIE_LOADED';
export const RANKING_DEX_ESPECIE_ERROR = 'RANKING_DEX_ESPECIE_ERROR';

export const DEX_ESPE_USER_LOADING = 'DEX_ESPE_USER_LOADING';
export const DEX_ESPE_USER_LOADED = 'DEX_ESPE_USER_LOADED';
export const DEX_ESPE_USER_ERROR = 'DEX_ESPE_USER_ERROR';

export const UNIRSE_DEX_LOADING = 'UNIRSE_DEX_LOADING';
export const UNISER_DEX_LOADED = 'UNISER_DEX_LOADED';
export const UNIRSE_DEX_ERROR = 'UNIRSE_DEX_ERROR';

export const DEX_LOADING_HOME = 'DEX_LOADING_HOME';
export const DEX_LOADED_HOME = 'DEX_LOADED_HOME';
export const DEX_ERROR_HOME = 'DEX_ERROR_HOME';

export const DEX_LOADING_HOME_SLIDER = 'DEX_LOADING_HOME_SLIDER';
export const DEX_LOADED_HOME_SLIDER = 'DEX_LOADED_HOME_SLIDER';
export const DEX_ERROR_HOME_SLIDER = 'DEX_ERROR_HOME_SLIDER';
export const DEX_REFRESH_HOME_SLIDER = 'DEX_REFRESH_HOME_SLIDER';

export const DEX_LOADING_DETAIL_HOME = 'DEX_LOADING_DETAIL_HOME';
export const DEX_LOADED_DETAIL_HOME = 'DEX_LOADED_DETAIL_HOME';
export const DEX_ERROR_DETAIL_HOME = 'DEX_ERROR_DETAIL_HOME';

export const DELETE_ITEM_DEX_LOADING = 'DELETE_ITEM_DEX_LOADING';
export const DELETE_ITEM_DEX_LOADED = 'DELETE_ITEM_DEX_LOADED';
export const DELETE_ITEM_DEX_ERROR = 'DELETE_ITEM_DEX_ERROR';

export const CREAR_ITEM_DEX_LOADING = 'CREAR_ITEM_DEX_LOADING';
export const CREAR_ITEM_DEX_LOADED = 'CREAR_ITEM_DEX_LOADED';
export const CREAR_ITEM_DEX_ERROR = 'CREAR_ITEM_DEX_ERROR';

export const EDITAR_DEX_ITEM_LOADING = 'EDITAR_DEX_ITEM_LOADING';
export const EDITAR_DEX_ITEM_LOADED = 'EDITAR_DEX_ITEM_LOADED';
export const EDITAR_DEX_ITEM_ERROR = 'EDITAR_DEX_ITEM_ERROR';

export const CREAR_DEX_LOADING = 'CREAR_DEX_LOADING';
export const CREAR_DEX_LOADED = 'CREAR_DEX_LOADED';
export const CREAR_DEX_ERROR = 'CREAR_DEX_ERROR';

export const EDITAR_DEX_LOADING = 'EDITAR_DEX_LOADING';
export const EDITAR_DEX_LOADED = 'EDITAR_DEX_LOADED';
export const EDITAR_DEX_ERROR = 'EDITAR_DEX_ERROR';

export const DEX_ITEM_LOADING = 'DEX_ITEM_LOADING';
export const DEX_ITEM_LOADED = 'DEX_ITEM_LOADED';
export const DEX_ITEM_ERROR = 'DEX_ITEM_ERROR';

export const DEX_UBICACIONES_LOADING = 'DEX_UBICACIONES_LOADING';
export const DEX_UBICACIONES_LOADED = 'DEX_UBICACIONES_LOADED';
export const DEX_UBICACIONES_ERROR = 'DEX_UBICACIONES_ERROR';
